import React from "react";
import {
  FiCheckCircle,
  FiAlertTriangle,
  FiX,
  FiArrowUpRight,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const typeStyles = {
  completed: {
    icon: <FiCheckCircle className="text-green-500" size={18} />,
    bg: "bg-white border-green-100",
    accent: "text-green-700",
  },
  error: {
    icon: <FiAlertTriangle className="text-red-500" size={18} />,
    bg: "bg-white border-red-100",
    accent: "text-red-700",
  },
};

function RealtimeToastStack({ notifications = [], onDismiss }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!notifications.length) return null;

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-3 pointer-events-none">
      {notifications.map((toast) => {
        const style = typeStyles[toast.eventType] || typeStyles.completed;
        return (
          <div
            key={toast.id}
            className={`pointer-events-auto w-80 rounded-2xl border shadow-xl p-4 transition transform hover:scale-[1.01] ${style.bg}`}
          >
            <div className="flex items-start gap-3">
              <div className="mt-1">{style.icon}</div>
              <div className="flex-1 text-sm text-gray-700">
                <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">
                  {toast.split
                    ? t("realtimeToast.split_progress", {
                        done: toast.split.done,
                        total: toast.split.total,
                      })
                    : toast.eventType === "completed"
                    ? t("realtimeToast.completed")
                    : t("realtimeToast.error")}
                </p>
                <p className="font-semibold text-gray-900">
                  {toast.filename || t("realtimeToast.document")}
                </p>
                {toast.scannerName && (
                  <p className="text-xs text-gray-500">{toast.scannerName}</p>
                )}
                <div className="flex items-center gap-2 mt-3">
                  <button
                    type="button"
                    onClick={() => {
                      const targetPath = toast.scannerId
                        ? `/scanners/${toast.scannerId}`
                        : "/upload";
                      navigate(targetPath, {
                        replace: false,
                        state: { focusResultId: toast.resultId },
                      });
                      onDismiss?.(toast.id);
                    }}
                    className={`flex items-center gap-1 text-xs font-semibold ${style.accent} hover:underline`}
                  >
                    {t("realtimeToast.view_detail")} <FiArrowUpRight size={14} />
                  </button>
                </div>
              </div>
              <button
                type="button"
                onClick={() => onDismiss?.(toast.id)}
                className="text-gray-400 hover:text-gray-600"
              >
                <FiX size={16} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default RealtimeToastStack;
